import {Component, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {NgForm, UntypedFormGroup} from '@angular/forms';
import { StoreService } from '../../../../../services/store.service';
import { IComponent } from '../../../../../types/step-component.interface';
import { IValidationSubComponent } from '../../../../../types/subcomponent-validation.interface';
import {markAllFieldsAsTouched} from "../../../../../shared/utils";
import {ParentGuardian} from "../../../../../types/parent-guardian.interface";
import {SubcomponentComponent} from "../../../../core/subcomponent.component";

@Component({
  selector: 'app-parent-guardian-info',
  templateUrl: 'parent-guardian-info.component.html'
})
export class ParentGuardianInfoComponent implements OnInit, IValidationSubComponent {
  @Input() metadata: IComponent;
  @ViewChildren('parentGuardian1') parentGuardian1: QueryList<SubcomponentComponent>;
  @ViewChildren('parentGuardian2') parentGuardian2: QueryList<SubcomponentComponent>;

  constructor(public storeService: StoreService) {}

  ngOnInit() {

  }

  get shouldShowParentGuardian2() {
    const vm = this.storeService.getCurrentState();
    return vm.populateParentGuardian2;
  }

  validate(): boolean {
    const validationComponents = [];
    validationComponents.push(this.parentGuardian1.last?.componentInstance);
    validationComponents.push(this.parentGuardian2.last?.componentInstance);

    let result = true;
    validationComponents.filter(o => !!o).forEach(o => {
      const cmpResult = o.validate();
      result = result && cmpResult;
    });
    return result;
  }
}
